import { faFaceFrown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import linearSad from '../../assets/img/linear_sad.svg';
import LinearFooterCmp from "../../components/footer/LinearFooter";
import { PlainInfoCard } from "../../components/styled/Card.style";
import { LEndSection, Section } from "../../components/styled/Containers.style";
import { IconContainer, LIconContainer } from "../../components/styled/Icon.style";
import { Vspace } from "../../components/styled/Separators.style";
import { BigText, LEndPageTitle, LEndText, TextDefault, TextDefaultSmall } from "../../components/styled/Text.style";
import { AUTH_CONFIRM_PATHS } from "../../routes/AuthConfirmRouter";
import { selectCommunicationData } from "../../store";
import { useAppSelector } from "../../store/hooks";
import PageContainerCmp from "../PageContainerCmp";

const AuthConfirmEndCancelPage = () => {

    const communicationData = useAppSelector(selectCommunicationData)
    const { communication } = communicationData
    const isLinear = communication?.companyName === "LINEAR";

    return (
        <>
            <PageContainerCmp
                routePath={AUTH_CONFIRM_PATHS.AUTHORIZE_CONFIRM_END_CANCEL}
                removeNextBtn={true}
                isForceLastPathname={true}
            >
                {!isLinear ?
                    <Section>
                        <PlainInfoCard>
                            <IconContainer>
                                <FontAwesomeIcon icon={faFaceFrown} />
                            </IconContainer>
                            <Vspace></Vspace>
                            <Vspace></Vspace>
                            <BigText>Procedura interrotta</BigText>
                        </PlainInfoCard>

                        <Vspace qty={2}></Vspace>
                        <TextDefault centered={true}><strong>Siamo spiacenti ma non è stato possibile portare a termine la procedura.</strong></TextDefault>
                        <Vspace qty={1}></Vspace>
                        <TextDefaultSmall>Contatta la tua Compagnia per proseguire. Grazie.</TextDefaultSmall>
                        <Vspace qty={8}></Vspace>
                    </Section>

                    :

                    <LEndSection>
                        <LIconContainer style={{ marginTop: "-220px" }}>
                            <img
                                src={linearSad}
                                alt="Procedura cancellata"
                                style={{ width: "250px" }}
                            />
                        </LIconContainer>
                        <LEndPageTitle>Procedura interrotta</LEndPageTitle>
                        <Vspace qty={2}></Vspace>
                        <LEndText>Hai deciso di non firmare, la procedura di firma è stata interrotta.</LEndText>
                    </LEndSection>}

                {!!isLinear ? <LinearFooterCmp inverted={true} /> : <></>}
            </PageContainerCmp>
        </>
    )
}

export default AuthConfirmEndCancelPage